module.exports = __webpack_public_path__ + "static/media/Account-X(whiteT).94c5162d.png";